import { PatientId, WithPatientId } from '../surgicalEvent.slice';
import { doctorBffApi } from '@/modules';
import { PregnancyInfoService } from './pregnancyInfo.service';
import { PregnancyInfo } from './pregnancyInfo.model';
import { wrapError } from '../../error';

export const pregnancyInfoApi = doctorBffApi.injectEndpoints({
  endpoints: (builder) => ({
    pregnancyInfo: builder.query<PregnancyInfo, PatientId>({
      queryFn: ({ patientId }) =>
        PregnancyInfoService.getInstance(patientId).fetch().catch(wrapError),
      providesTags: (result, error, { patientId }) => [
        { type: 'PregnancyInfo', id: patientId }
      ]
    }),

    patchPregnancyInfo: builder.mutation<
      PregnancyInfo,
      WithPatientId<Partial<PregnancyInfo>>
    >({
      queryFn: ({ patientId, ...pregnancyInfo }) =>
        PregnancyInfoService.getInstance(patientId)
          .patch(pregnancyInfo)
          .catch(wrapError),
      invalidatesTags: (result, error, { patientId }) => [
        { type: 'PregnancyInfo', id: patientId },
        'Dashboard'
      ]
    }),

    clearPregnancyInfo: builder.mutation<PregnancyInfo, PatientId>({
      queryFn: ({ patientId }) =>
        PregnancyInfoService.getInstance(patientId).clear().catch(wrapError),
      invalidatesTags: (result, error, { patientId }) => [
        { type: 'PregnancyInfo', id: patientId },
        'Dashboard'
      ]
    })
  }),
  overrideExisting: false
});

export const {
  usePregnancyInfoQuery,
  usePatchPregnancyInfoMutation,
  useClearPregnancyInfoMutation
} = pregnancyInfoApi;
